import axios from "axios";

export const getCompanies = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/companies", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getCompany = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/companies/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createCompany = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/companies`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const updateCompany = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/companies/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const signInCompany = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/companies/${data?.id}/signin`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const archiveCompany = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/companies/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const restoreCompany = async ({ data, update }: any) => {
	try {
		const res: any = await axios.post(`/companies/${data?.id}/restore`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resendCompanyInvite = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/companies/${data.id}/resend-invite`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getMyCompany = async () => {
	try {
		const res: any = await axios.get(`/companies/my`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
}

export const updateMyCompany = async ({ update }: any) => {
	try {
		const res: any = await axios.put(`/companies/update`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getInstantEstimateCombos = async () => {
	try {
		const res: any = await axios.get(`/companies/template-products`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
}

export const getInstantEstimateCombo = async ({data}:any) => {
	try {
		const res: any = await axios.get(`/companies/template-product/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	} 
}

export const saveInstantEstimateCombos = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/companies/template-products`, data);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateInstantEstimateCombos = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/companies/template-products/${data}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const deleteInstantEstimateCombo = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/companies/template-products/${data}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};